import api from "./api";

export const getsAreaObjetivoCriterioResumenView = async (filters) => {
    const response = await api.get('/Modelo/GetsAreaObjetivoCriterioResumenView?'
            + 'idModelo=' + (filters.idModelo == null ? 0 : filters.idModelo)
            + '&codigoModelo='
            + '&modelo='
            + '&idArea=' + (filters.idArea == null ? 0 : filters.idArea)
            + '&codigoArea='
            + '&area='
            + '&idDestreza=0'
            + '&codigoDestreza='
            + '&destreza=' + (filters.destreza == null ? "" : filters.destreza)
            + '&idAreaObjetivo=0'
            + '&codigoObjetivo='
            + '&objetivo=' + (filters.objetivo == null ? "" : filters.objetivo)
            + '&idAreaObjetivoCriterio=0'
            + '&valor=0'
            + '&descripcion=' + (filters.criterio == null ? "" : filters.criterio)
            + '&orden=0'
        );

    return response.data.data;
}

export const getsListModelo = async () => {
    const response = await api.get('/Modelo/GetsListModelo');

    return response.data.data;
}

export const getsListArea = async (idModelo) => {
    const response = await api.get('/Modelo/GetsListArea?'
            + 'idModelo=' + idModelo
        );

    return response.data.data;
}
